(function () {
    function initMediaSliders(context = document) {
        var sliders = context.querySelectorAll('.product-card__media-slider:not([data-slider-init])');
        sliders.forEach(function (slider) {
            slider.setAttribute('data-slider-init', 'true');
            var images = slider.querySelectorAll('img');
            var pictures = slider.querySelectorAll("picture");
            var current = 0;
            var dotsContainer = slider.parentElement.querySelector('.product-slider-dots');
            var dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : null;

          
            function loadPicture(pic) {
                if (!pic.dataset.loaded) {
                    console.log("loadPicture !pic.dataset.loaded");
                    var sources = pic.querySelectorAll("source");
                    var img = pic.querySelector("img");

                    sources.forEach(source => {
                        if (source.dataset.srcset) {
                            source.srcset = source.dataset.srcset;
                        }
                    });

                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                    }

                    pic.dataset.loaded = true;
                }
            }
            // loadPicture(pictures[0]);

            if (images.length <= 1) return;

            if (dots) {
                dots.forEach(function (dot, index) {
                    dot.addEventListener('click', function () {
                        images[current].classList.remove('active');
                        dots[current].classList.remove('active');
                        current = index;
                        images[current].classList.add('active');
                        dots[current].classList.add('active');
                        //loadPicture(pictures[index]); // Load current image
                    });
                });
            }

            var startX = 0, endX = 0, threshold = 20;
            slider.addEventListener('touchstart', e => startX = e.touches[0].clientX, { passive: true });
            slider.addEventListener('touchmove', function (e) {
                endX = e.touches[0].clientX;
                if (Math.abs(startX - endX) > threshold) e.preventDefault();
            }, { passive: false });
            slider.addEventListener('touchend', function () {
                var diff = startX - endX;
                if (Math.abs(diff) <= threshold) return;
                images[current].classList.remove('active');
                if (dots) dots[current].classList.remove('active');
                current = diff > 0
                    ? (current + 1) % images.length
                    : (current - 1 + images.length) % images.length;
                images[current].classList.add('active');
                if (dots) dots[current].classList.add('active');
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initMediaSliders();
    });

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (!(node instanceof HTMLElement)) return;
                if (node.matches('.product-card__media-slider') ||
                    node.querySelector('.product-card__media-slider')) {
                    initMediaSliders(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

document.addEventListener('DOMContentLoaded', function () {
    console.log("In");
    const optionNameEls = document.querySelectorAll('.variant-picker__option-info legend');
    const addToCartBtns = document.querySelectorAll('.buy-buttons button[type="submit"]');
    let variantOptions;
    let didInsertMessage = false;

    optionNameEls.forEach((optionEl) => {
        if (optionEl.innerText.trim().toLowerCase().includes("size")) {
            variantOptions = optionEl.closest('.variant-picker__option-info').nextElementSibling;
        }
    });

    if (addToCartBtns.length > 0 && variantOptions) {
        /*function animateVariantOptions(event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            variantOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });

            if (!didInsertMessage) {
                const message = document.createElement('p');
                message.innerText = 'Please select a size';
                message.style.color = 'red';
                variantOptions.insertAdjacentElement('beforebegin', message);
                didInsertMessage = true;
            }

            setTimeout(() => {
                variantOptions.classList.add('animate-once');
                const onAnimationEnd = () => {
                    variantOptions.classList.remove('animate-once');
                    variantOptions.removeEventListener('animationend', onAnimationEnd);
                };
                variantOptions.addEventListener('animationend', onAnimationEnd);
            }, 500);
        }*/

        // addToCartBtns.forEach((btn) => {
        //     btn.addEventListener('click', animateVariantOptions);
        // });

        // variantOptions.addEventListener('click', function handleVariantClick() {
        //     addToCartBtns.forEach((btn) => {
        //         btn.removeEventListener('click', animateVariantOptions);
        //     });
        //     variantOptions.removeEventListener('click', handleVariantClick);
        // });
    }

    function checkAllScrolls() {
        const scrollWrappers = document.querySelectorAll('.variant-picker__option-values');

        scrollWrappers.forEach(wrapper => {
            const scrollIndicator = wrapper.parentElement.querySelector('.scroll-indicator');

            if (!scrollIndicator) return;

            if (wrapper.scrollWidth > wrapper.clientWidth) {
                scrollIndicator.style.display = 'none';
            } else {
                scrollIndicator.style.display = 'none';
            }
        });
    }

    window.addEventListener('resize', checkAllScrolls);
    window.addEventListener('load', checkAllScrolls);

    document.addEventListener('click', function (e) {
        if (e.target.closest('.variant-picker__option-values')) {
            setTimeout(checkAllScrolls, 50);
        }
    });

    const labelElement = document.querySelector('.variant-picker__option-values label');
    const quantitySelector = document.querySelector('.quantity-selector:not(.cart-drawer__items .quantity-selector)');
    if (labelElement && quantitySelector) {
        const labelHeight = parseFloat(window.getComputedStyle(labelElement).height);
        const newHeight = labelHeight * 1.09;
        quantitySelector.style.height = newHeight + 'px';
        quantitySelector.style.gridAutoRows = newHeight + 'px';
        quantitySelector.style.setProperty('--quantity-selector-height', newHeight + 'px');
        if (window.matchMedia("(max-width: 768px)").matches) {
            console.log('Mobile view detected');
            quantitySelector.style.width = '35vw';
        }
    }
});